"use client";

import { cn } from "@/utils/helpers";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Switch } from "../ui/switch";

export default function ThemeToggle() {
  const { setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => setMounted(true), 0);
  }, []);

  if (!mounted) {
    return <div className="h-[24px] w-[44px] rounded-full" />;
  }

  return (
    <div className="relative flex w-fit items-center">
      <Switch
        checked={resolvedTheme === "dark"}
        onCheckedChange={() => setTheme(resolvedTheme === "light" ? "dark" : "light")}
      />
      <Sun
        size={16}
        className={cn(
          "pointer-events-none absolute right-1 top-1/2 z-50 -translate-y-1/2 opacity-0",
          resolvedTheme === "light" && "opacity-70",
        )}
      />
      <Moon
        size={16}
        className={cn(
          "pointer-events-none absolute left-1 top-1/2 z-50 -translate-y-1/2 opacity-0",
          resolvedTheme === "dark" && "stroke-background opacity-70",
        )}
      />
    </div>
  );
}
